import * as React from "react"
import { MobileBookingTotals } from "./MobileBookingTotals"

type Props = {
    amountPence: number
    deliveryPence: number | null
    dates?: { deliveryDate: string; collectionDate: string }
    busy: boolean
    disabled: boolean
    label: React.ReactNode
    onPay: () => void
}

export function MobilePaymentFooter({ amountPence, deliveryPence, dates, busy, disabled, label, onPay }: Props) {
    const footerRef = React.useRef<HTMLDivElement>(null)
    React.useLayoutEffect(() => {
        const footer = footerRef.current
        const app = footer?.closest<HTMLElement>(".booking-app")
        if (!footer || !app) return
        // Keep the page footer clear as the action bar changes, including fractional-pixel layout rounding.
        const update = () => app.style.setProperty("--booking-payment-footer-height", `${Math.ceil(footer.getBoundingClientRect().height) + 1}px`)
        update()
        const observer = new ResizeObserver(update)
        observer.observe(footer)
        return () => { observer.disconnect(); app.style.removeProperty("--booking-payment-footer-height") }
    }, [])

    return <div ref={footerRef} className="ah-mobile-bar ah-mobile-payment-footer">
        <MobileBookingTotals amountPence={amountPence} deliveryPence={deliveryPence} dates={dates} />
        <button type="button" className="ah-primary-button ah-pay-button" disabled={disabled} aria-busy={busy} onClick={onPay}>{label}</button>
    </div>
}
